var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Editor, Element } from "slate";
export var isBlockActive = function (editor, format, blockType) {
    if (blockType === void 0) { blockType = "type"; }
    var selection = editor.selection;
    if (!selection)
        return false;
    if (format === "sub-title") {
        var _a = __read(Array.from(Editor.nodes(editor, {
            at: Editor.unhangRange(editor, selection),
            match: function (n) {
                return (!Editor.isEditor(n) &&
                    Element.isElement(n) &&
                    ["heading-one", "heading-two"].includes(n[blockType]));
            },
        })), 1), match = _a[0];
        return !!match;
    }
    else {
        var _b = __read(Array.from(Editor.nodes(editor, {
            at: Editor.unhangRange(editor, selection),
            match: function (n) {
                if (blockType === "align") {
                    return false;
                }
                return (!Editor.isEditor(n) &&
                    Element.isElement(n) &&
                    n[blockType] === format);
            },
        })), 1), match = _b[0];
        return !!match;
    }
};
